
import Constant from "@constant/index.js";
import Intercept from "@observer/Intercept.js";

export default class SubscribeSnapView{
    constructor(model){
        this._model = model;
        this._model._view = this;
        this._parentEl = this._model._parent._view._headerBoxEl;
        this._el = null;
    }

    render(){
        let html = "";
     
        if((!this._model._parent._option || this._model._parent._option == null) && this._model._flags == 4){
            // console.log(this)
            this._model._isCanScribe = false
            this._model._lastDesc = ''
        }
        if(this._model._leftTime && (this._model._parent._parent._itemType != Constant.GROUP_TYPE.PACKAGE.TYPE)){
            html += `<div class="good_item_head" tag='subscribesnap'>
                <span class="item le_tag">${this._model._name}</span>
                <span class="item"><span tag='subscribesnapdesc'>${this._model._desc}</span>&nbsp;<span class="le_color_red" tag='subscribesnapleft'>${this._model._leftTime}</span></span>
                <span class="item le_color_red" tag="goBooking">
                    <a target="_blank" href="${this._model._parent._link}" style="display:${this._model._isCanScribe?'inline-block':'none'};" tag='subscribesnaplastdesc'>${this._model._lastDesc}</a>${this._model._lastDesc?'<i class="iconfont icon-arrow-right le_vertical_align_m"></i>':''}
                </span>
            </div>`
            // if(this._model._parent._parent._itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE){
            //     $(this._parentEl).append($(html));
            // }else{
            //     $(this._parentEl).prepend($(html));
            // }
            $(this._parentEl).append($(html));
            this._el = $(this._parentEl).find("[tag='subscribesnap']");
            this.interceptList();
        }
    }

    interceptList(){
        let time = $(this._el).find("[tag=subscribesnapleft]");
        new Intercept().init(time, this._model, "_leftTime");

        let desc = $(this._el).find("[tag=subscribesnapdesc]");
        new Intercept().init(desc, this._model, "_desc");
        //checked
        let checkedEl = $(this._el).find("[tag=goBooking]");
        new Intercept().init(checkedEl, this._model, "_isCanScribe", 'show');
        let lastDesc = $(this._el).find("[tag=subscribesnaplastdesc]");
        new Intercept().init(lastDesc, this._model, "_lastDesc");
    }
}